module.exports = "/_next/static/images/harajuku_date_lunch-2ade0b96785418b5cfe6ea6ddc7d7f42.jpg";